import { Component } from '@angular/core';
import { Subject, switchMap, takeUntil } from 'rxjs';
import { IGetEpisodesOfCare } from 'src/app/interfaces/IGetEpisodesOfCare';
import { EpisodeOfCareService } from 'src/app/services/episodeOfCare.service';
import { DischargeReportService } from 'src/app/services/dischargeReport.service';
import { PermissionService } from 'src/app/services/permission.service';
import { VisitExpandComponent } from '../visit-expand/visit-expand.component';
import { LocaleService } from 'src/app/services/locale.service';

@Component({
  selector: 'app-past-eoc',
  templateUrl: './past-eoc.component.html',
  styleUrls: ['./past-eoc.component.css'],
  standalone: false,
})
export class PastEocComponent {
  public expandComp = VisitExpandComponent;

  private destroy$ = new Subject<void>();

  isLoading = false;
  episodesOfCare: IGetEpisodesOfCare[] = [];

  customActions = [
    {
      iconType: 'icons:dischargeReport',
      tooltip: 'Discharge report',
      handler: (item: IGetEpisodesOfCare) =>
        this.dischargeReportService.open(item.id!),
      isVisible: (item: IGetEpisodesOfCare) =>
        !!item?.isHospitalized &&
        !item?.hasIssuedDischargeReport &&
        this.permissionService.can(['disc']),
    },
    {
      iconType: 'download',
      tooltip: 'Download discharge report',
      handler: (item: IGetEpisodesOfCare) =>
        this.dischargeReportService.downloadPdf(item.issuedDischargeReportId!),
      isVisible: (item: IGetEpisodesOfCare) =>
        !!item?.hasIssuedDischargeReport &&
        item?.issuedDischargeReportId != null,
    },
  ];

  constructor(
    private readonly eocService: EpisodeOfCareService,
    private readonly dischargeReportService: DischargeReportService,
    private readonly permissionService: PermissionService,
    private readonly localeService: LocaleService,
  ) {}

  ngOnInit() {
    this.eocService.pastEocLoadingSub
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: boolean) => {
        this.isLoading = data;
      });

    this.eocService.pastEocDataSub
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: IGetEpisodesOfCare[]) => {
        this.episodesOfCare = data;
      });

    this.localeService.locale$
      .pipe(
        switchMap(() => this.eocService.loadPastData()),
        takeUntil(this.destroy$),
      )
      .subscribe();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
